import React from 'react'
import { Feed, Divider, Icon } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';
import MomentDate from './../../../../../common/MomentDate';
import MomentTime from '../../../../../common/MomentTime';
import ImageAvater from '../../../../../drive/Components/ImageAvater';

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext(props.name)
    }
})


class CommentLogsCard extends React.Component {
    render() {
        return (
            <Feed className={`issueMessage  `} >
                <Feed.Event className="pad_5">
                    <Feed.Content>
                        <Feed.Summary className="clr-blue">
                            {this.props.item.phase} <Icon name="chevron right" />
                            {this.props.item.stage && this.props.item.stage} {this.props.item.stage && <Icon name="chevron right" />}
                            {this.props.item.activityName}
                            <span className="pull-right"> <Icon className="clr-yellow" name="pause circle" /></span>
                        </Feed.Summary>
                    </Feed.Content>
                </Feed.Event>
                <Divider className="mar_0" />
                <Feed.Event className="pad_5">
                    <ImageAvater user={this.props.item.data && this.props.item.data.accountUserId} />
                    <Feed.Content>
                        <Feed.Summary>
                            {this.props.item.data && this.props.item.data.accountUserId.firstName + ' ' + this.props.item.data.accountUserId.lastName}
                            <span className="pull-right"><MomentDate date={this.props.item.data.createdDate} /> </span>
                        </Feed.Summary>
                        <Feed.Date>
                            <span>has marked this activity as active</span>
                            <span className="pull-right" style={{ textAlign: "right" }}>
                                <MomentTime date={this.props.item.data.createdDate} />
                            </span>
                        </Feed.Date>
                    </Feed.Content>
                </Feed.Event>
                <Divider className="mar_lr_3" />
                <div className="pad_5">
                    <div dangerouslySetInnerHTML={{ __html: this.props.item.data.activateComment }} />

                </div>
                <div className="stratchSeprator"></div>
                <Feed.Event className="pad_5">
                    <ImageAvater user={this.props.item.data && this.props.item.data.accountUserId} />
                    <Feed.Content>
                        <Feed.Summary>
                            {this.props.item.data && this.props.item.data.accountUserId.firstName + ' ' + this.props.item.data.accountUserId.lastName}
                            <span className="pull-right"><MomentDate date={this.props.item.data.createdDate} /> </span>
                        </Feed.Summary>
                        <Feed.Date>
                            <span>has put this activity on hold</span>
                            <span className="pull-right" style={{ textAlign: "right" }}>
                                <MomentTime date={this.props.item.data.createdDate} /></span></Feed.Date>
                    </Feed.Content>
                </Feed.Event>
                <Divider className="mar_lr_3" />
                <div className="pad_5">
                    <div dangerouslySetInnerHTML={{ __html: this.props.item.data.comment }} />

                </div>
            </Feed>


        )
    }
}

export default CommentLogsCard